import APIClient from '../../services/APIClient';
import { makeApiCall } from '../../services/ApiService';

export default {

    getAccounts: (params: any) => makeApiCall({
        startCallMessage: 'API: Fetching Accounts Data',
        successMessage: 'API: Successfully Fetched Accounts Data',
        failureMessage: 'API: Fetching Accounts Failed',
        params,
        url: `/admin/accounts`,
        method: APIClient.get,
        data: null,
        config: null,
        shouldShowNotifications: true,
        extractPath: (data) => data.accounts,
    }),

    getAccount: (data: any) => makeApiCall({
        startCallMessage: 'API: Fetching Accounts Data',
        successMessage: 'API: Successfully Fetched Accounts Data',
        failureMessage: 'API: Fetching Accounts Failed',
        params: {},
        url: `/admin/accounts` + (data.searchId ? `/${data.searchId}` : ''),
        method: APIClient.get,
        data: null,
        config: null,
        shouldShowNotifications: false,
        extractPath: (data) => data.account,
    }),

    editAccount: (data: any) => makeApiCall({
        startCallMessage: 'API: Fetching Account Data',
        successMessage: 'API: Successfully Fetched Account Data',
        failureMessage: 'API: Fetching Account Failed',
        data,
        url: '/admin/accounts' + (data._id ? `/${data._id}` : ''),
        method: APIClient.put,
        config: null,
        shouldShowNotifications: true,
        extractPath: (data) => data.account,
    }),

    deleteAccounts: (data: any) => makeApiCall({
        startCallMessage: 'API: Fetching Account Data',
        successMessage: 'API: Successfully Fetched Account Data',
        failureMessage: 'API: Fetching Account Failed',
        data,
        url: `/admin/accounts/delete`,
        method: APIClient.post,
        config: null,
        shouldShowNotifications: true,
        extractPath: (data) => data.accounts,
    }),

}
